import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import behalfSuggestions from '@integrations/pint-appstore-commons/src/components/behalfSuggestions';
import { suggestApp, closeSuggestion } from './appSuggestionActionCreators';
import SuggestionFormModal from './SuggestionFormModal';
import SuggestionSubmittedModal from './SuggestionSubmittedModal';

function AppSuggestion(props) {
    const onSubmitSuggestion = (appName, description, domain) => props.dispatchSuggestApp(appName, description, domain);
    const onCloseSuggestion = () => props.dispatchCloseSuggestion();

    if (!props?.active) return null;

    return !props.suggestionSubmitted ? (
        <SuggestionFormModal
            submitSuggestion={onSubmitSuggestion}
            closeSuggestion={onCloseSuggestion}
            isBehalfOfCustomerEnabled={behalfSuggestions.isDomainEnabledForBehalfSuggestion(props.pageDomain)}
            isFetching={props.isFetching}
        />
    ) : (
        <SuggestionSubmittedModal closeSuggestion={onCloseSuggestion} displayName={props.displayName} />
    );
}
AppSuggestion.propTypes = {
    isFetching: PropTypes.bool,
    displayName: PropTypes.string,
    pageDomain: PropTypes.string,
    suggestionSubmitted: PropTypes.bool,
    dispatchSuggestApp: PropTypes.func,
    dispatchCloseSuggestion: PropTypes.func,
    active: PropTypes.bool,
};

const mapDispatchToProps = {
    dispatchSuggestApp: suggestApp,
    dispatchCloseSuggestion: closeSuggestion,
};

export default connect(
    (state) => ({ ...state.appSuggestion, displayName: state.user.displayName, pageDomain: state.user.pageDomain }),
    mapDispatchToProps
)(AppSuggestion);
